import GSAP from 'gsap'
import ClassWatcher from '../components/ClassWatcher'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { hideOnClickOutside } from '../utils/utils'

GSAP.registerPlugin(ScrollTrigger)

export default class VideoCloud {
	constructor(el) {

		let container 			= el;
		this.videoWrapper		= el.querySelector(".video-cloud__wrapper");
		this.videoCloudTitle	= el.querySelector(".video-cloud__textscrollgroup");
		this.videos 			= [...container.querySelectorAll(".video") ]
		this.workOnClassAdd		= this.workOnClassAdd.bind(this)
		this.workOnClassRemoval	= this.workOnClassRemoval.bind(this)
		this.openLightbox		= this.openLightbox.bind(this)
		this.closeLightbox		= this.closeLightbox.bind(this)
		this.isClicked 			= false
		this.videoAnimation		= [];
		this.scrollTimeline;

		if(this.videoCloudTitle){
			this.scrollTimeline = GSAP.to( this.videoCloudTitle, {
				y: '-50%',
				scrollTrigger: {
					trigger: this.videoWrapper,
					start: "top bottom",
					end: "bottom top",
					scrub: 0.5
				},
				onComplete: self => {
					// console.log('end');
				},
				// onUpdate: (self) => {
				// 	console.log("velocity:", self.getVelocity())
				// }
			})
		}

		this.videos.forEach((video, index) => {

			// SET ALL TO CLOSED
			this.videos[index].isOpen = false;

			// CREATE A TIMELINE FOR EACH VIDEO, WITH A UNIQUE NAME
			this.videoAnimation[index] = GSAP.timeline({
				reversed: true, 
				paused: true, 
				defaults: {
					duration: 1,
					overwrite: true,
				}
			});	

			video.addEventListener("click", () => {

				// console.log('index: ' + index)
				let windowHeight	= window.innerHeight/2
				let bodyHeight 		= window.document.body.clientHeight				

				// WE NEED TO GET THE CURRENT SCROLL DISTANCE:
				// - From the top of the .video-cloud__wrapper to the top of the screen
				// - Start with getting the real scrolldistance from ScrollSmoother.progress
				// - Then find the difference between scrollDistance and our container
				// - Then we can work out the distance needed from the top of the container to make it centered on screen

				// If we are on a mobile device then scroll smoother is not used, so we need to use the actual window scroll
				if( window.app.isMobile ){
					
					let scrollDistance 	= document.documentElement.scrollTop // GET CURRENT DISTANCE SCROLLED ON DOCUMENT
					let scrollOffset	= scrollDistance  - this.videoWrapper.offsetTop // GET DISTANCE OF WRAPPER FROM CURRENT SCROLL
					this.yPosition 		= '60vh'

					// console.log(document.documentElement.scrollTop);
					// console.log('scrollDistance: ' + scrollDistance)
					// console.log('wrapperOffset: ' + this.videoWrapper.offsetTop)
					// console.log('scrollOffset: ' + scrollOffset)
					// console.log('yPosition: ' + this.yPosition)
					
				} else {
					// console.log('Smoother progress: ' + window.app.smoother.progress);
					let scrollDistance 	= (bodyHeight - window.innerHeight ) * window.app.smoother.progress // GET CURRENT DISTANCE SCROLLED ON DOCUMENT
					let scrollOffset	= scrollDistance  - window.app.smoother.offset(this.videoWrapper, "top top") // GET DISTANCE OF WRAPPER FROM CURRENT SCROLL
					this.yPosition 		= (scrollOffset + windowHeight) - 100

					// console.log('scrollDistance: ' + scrollDistance)
					// console.log('scrollOffset: ' + scrollOffset)
					// console.log('yPosition: ' + this.yPosition)

					let width = GSAP.getProperty(video, 'width');
					let height = GSAP.getProperty(video, 'height');
					let top = GSAP.getProperty(video, 'top');
					let bottom = GSAP.getProperty(video, 'bottom');
					let yPosition = GSAP.getProperty(video, 'translateY');
					// console.log(yPosition);
					this.videoAnimation[index].fromTo(video, {
						y: yPosition,
						// x: 0,
						// xPercent: -50,
						// yPercent: yPosition,
						width: width,
						height: height,
						top: top,
						bottom: bottom,
						// left: '50%',
						bottom: 'auto',
					}, {
						y: 0,
						x: 0,
						xPercent: -50,
						yPercent: -50,
						width: '368px',
						height: '60vh',
						top: this.yPosition,
						left: '50%',
						bottom: 'auto',
						zIndex: 99,
						// overwrite: true,
						duration: 0.5,
					}, "<");

				}

				hideOnClickOutside( video, 'video-cloud--open', 'video--fixed' )
				
				// Toggle event listener
				if(this.videos[index].isOpen == true){

					// CLOSE VIDEO
					this.closeLightbox(index)

				} else {

					// OPEN VIDEO
					this.openLightbox(index)

				}

			})

		});
		
		let classWatcher = new ClassWatcher(document.body, 'video-cloud--open', this.workOnClassAdd, this.workOnClassRemoval)

	}

	openLightbox(index){
		document.body.classList.add("video-cloud--open")
		this.videos[index].classList.add('video--fixed')
		this.videos[index].isOpen = true
		this.videoAnimation[index].play()


		// GRABBING Y TRANSLATE IN HOPES OF RETURNING TO IT FOR SMOOTHER ANIMATIONS
		// - https://stackoverflow.com/questions/42267189/how-to-get-value-translatex-by-javascript
		function getTranslateXY(element) {
			const style = window.getComputedStyle(element)
			const matrix = new DOMMatrixReadOnly(style.transform)
			return {
				translateX: matrix.m41,
				translateY: matrix.m42
			}
		}
		let transform = getTranslateXY(window.app.VideoCloud.videos[index]);
		// console.log('window computed style: ' + transform.translateY)
		window.app.VideoCloud.videos[index].yTranslatePosition = transform.translateY;


		if(!window.app.isMobile){
			let realVideo = window.app.VideoCloud.videos[index].querySelector('.video__desktop')
			GSAP.to( realVideo, {
				y: 0,
				height: '100%',
				overwrite: true,
			})
			if(window.app.smoother) {
				window.app.smoother.paused(true)
			}
		}
	}

	closeLightbox(index){
		document.body.classList.remove("video-cloud--open")
		this.videos[index].classList.remove('video--fixed')
		this.videos[index].isOpen = false
		this.videoAnimation[index].reverse()

		// console.log(window.app.VideoCloud.videos[index].yTranslatePosition)

		if(window.app.VideoCloud.videos[index].yTranslatePosition == null){
			window.app.VideoCloud.videos[index].yTranslatePosition = 0
		}

		if(!window.app.isMobile){
			let realVideo = window.app.VideoCloud.videos[index].querySelector('.video__desktop')
			GSAP.to( realVideo, {
				height: '150%',
			})
			if(window.app.smoother) {
				window.app.smoother.paused(false)
			}
		}
	}

	workOnClassAdd(index) {

	}

	workOnClassRemoval() {

		if(!window.app.isMobile){

			window.app.VideoCloud.videoAnimation.forEach((video, index)=> {
				if(window.app.VideoCloud.videos[index].isOpen == true){

					this.closeLightbox(index)

				}
			})

		}

	}

}
